import { useEffect, useRef, useState } from "react";

import { SYSTEM_COLORS } from "../../../../components/system.colors";

const ChevronBadge = ({ open }) => (
  <span style={{
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    inlineSize: "1.35rem", blockSize: "1.35rem", borderRadius: "50%",
    background: SYSTEM_COLORS.ORANGE.DEEP_ORANGE, flexShrink: 0,
  }}>
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.WHITE.WHITE} strokeWidth="3"
      strokeLinecap="round" strokeLinejoin="round"
      style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .15s" }}>
      <polyline points="6 9 12 15 18 9" />
    </svg>
  </span>
);

const PlainChevron = ({ open }) => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.GRAY.GREY} strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round"
    style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .15s", flexShrink: 0 }}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const FilterPill = ({ctx, onChange, variant = "active" }) => {
  const {icon, label, options, value} = ctx || {};
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (event) => { if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const selectedLabel = options?.find((option) => option.key === value)?.label ?? label;

  return (
    <div ref={rootRef} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        style={{
          display: "flex", alignItems: "center", gap: "0.5rem",
          padding: variant === "active" ? "0.3rem 0.3rem 0.3rem 0.9rem" : "0.45rem 0.9rem",
          border: `1px solid ${SYSTEM_COLORS.GRAY.GAINSBORO}`, borderRadius: "999px",
          background: SYSTEM_COLORS.WHITE.WHITE, cursor: "pointer",
          fontSize: "0.85rem", fontWeight: 500, color: SYSTEM_COLORS.BLACK.JET, whiteSpace: "nowrap",
        }}>
        {icon}
        <span>{selectedLabel}</span>
        {variant === "active" ? <ChevronBadge open={open} /> : <PlainChevron open={open} />}
      </button>

      {open && options?.length > 0 && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", left: 0, minWidth: "max(100%, 160px)",
          background: SYSTEM_COLORS.WHITE.WHITE, border: `1px solid ${SYSTEM_COLORS.GRAY.SILVER}`,
          borderRadius: "12px", boxShadow: `0 8px 24px ${SYSTEM_COLORS.BLACK.BLACK_12_PERCENT}`,
          zIndex: 999, padding: "0.3rem 0",
        }}>
          {options.map((option) => (
            <button
              key={option.key}
              onClick={() => { onChange(option.key); setOpen(false); }}
              style={{
                width: "100%", display: "flex", alignItems: "center", gap: "0.5rem",
                padding: "0.5rem 0.9rem", background: option.key === value ? SYSTEM_COLORS.WHITE.WHITE_SMOKE : "none",
                border: "none", cursor: "pointer", fontSize: "0.83rem", color: SYSTEM_COLORS.BLACK.EERIE_BLACK,
                fontWeight: option.key === value ? 700 : 400, textAlign: "left", whiteSpace: "nowrap",
              }}>
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
